var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB1Battery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h-6v-4h6v-6h4v6h6v4h-6v6h-4v-6zm25-9v14h-5v6a4 4 0 01-4 4H10a4 4 0 01-4-3.86V24.92A4 4 0 0110 21h52a4 4 0 014 4v6h5zm-9-6H10v26h52V25zM31 36H17v4h14v-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B1_Battery.157a6fc4.svg";
export { SvgB1Battery as ReactComponent };